/* SVGR has dropped some elements not supported by react-native-svg: title */
export const SvgList = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="lucide lucide-list-icon lucide-list text-primary"
  >
    <path d="M3 12h.01M3 18h.01M3 6h.01M8 12h13M8 18h13M8 6h13" />
  </svg>
);
export const SvgGrid = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="lucide lucide-grid2x2-icon lucide-grid-2x2 text-primary"
  >
    <path d="M12 3v18M3 12h18" />
    <rect width={18} height={18} x={3} y={3} rx={2} />
  </svg>
);
